module.exports = __webpack_public_path__ + "03e665e9c31bb2293554c5e798a675a9.png";